



/* FOXPOST line */
document.addEventListener("DOMContentLoaded", function () {
  console.log("Foxpost script loaded");

  function insertFoxpostText() {
    console.log("Looking for .cart-order__summary...");

    const container = document.querySelector(".cart-order__summary");

    if (!container) {
      console.log(".cart-order__summary NOT found");
      return;
    }

    console.log(".cart-order__summary FOUND");

    if (document.querySelector("#foxpost-info")) {
      console.log("Foxpost text already exists");
      return;
    }

    let text = "";
    const lang = document.documentElement.lang || "hu";
    console.log("Detected language:", lang);

    if (lang.startsWith("en")) {
      text = "A maximum of 8 items can be ordered to a Foxpost parcel locker depending on the size.";
    } else if (lang.startsWith("de")) {
      text = "Je nach Größe können maximal 8 Produkte in eine Foxpost-Paketstation bestellt werden.";
    } else {
      text = "Foxpost csomagautomatába a méretétől függően legfeljebb 8 darab termék rendelhető.";
    }

    const info = document.createElement("div");
    info.id = "foxpost-info";
    info.style.marginTop = "12px";
    info.style.fontSize = "14px";
    info.innerText = text;

    console.log("Appending text to .cart-order__summary");
    container.appendChild(info);
  }

  // egyszer fut + observer ha később tölt be
  insertFoxpostText();

  const observer = new MutationObserver(function () {
    console.log("Mutation detected");
    insertFoxpostText();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});







/* szálloda kollekciók */
  window.addEventListener('load', () => {
    const elements = document.querySelectorAll('#scroll-area-template--18622114529469__image_link_blocks_pWy7nM .content-over-media');

    elements.forEach(el => {
      const img = el.querySelector('img');
      const textBlock = el.querySelector('#scroll-area-template--18622114529469__image_link_blocks_pWy7nM .place-self-end-start');

      if (img && textBlock) {
        const updateWidth = () => {
          const imgWidth = img.clientWidth;
          textBlock.style.width = imgWidth + 'px';
        };

        updateWidth();

        // Figyeljük, ha az ablak mérete változik
        window.addEventListener('resize', updateWidth);
      }
    });
  });







/* szó váltakozás */
document.addEventListener("DOMContentLoaded", () => {
  const words = [
    "panzióknak",
    "szállodáknak",
    "vendéglátóhelyeknek",
    "éttermeknek",
    "luxushoteleknek"
  ];

  let index = 0;

  const selector = "#block-image_i4GtjV > div > div > div > p.subheading";
  const targetElement = document.querySelector(selector);

  if (targetElement) {
    const prefix = "Czinger Home minőség ";

    setInterval(() => {
      targetElement.textContent = prefix + words[index];
      index = (index + 1) % words.length;
    }, 1500);
  } else {
    console.error("Nem található a megadott selector:", selector);
  }
});







document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(
    "#scroll-area-template--18622114529469__image_link_blocks_pWy7nM > div"
  );

  const texts = [
    "Áthajtós vagy cipzáros kivitelben, akár egyedi méretben", // 1
    "Mérettartó, akár 90 °C-on mosható, vízhatlan frottír matracvédők", // 2
    "Antiallergén, formatartó kiválóságok, szilikonizált poliészter töltettel", // 3
    "Frottír törölközők, kádkilépők, köntösök, papucsok puha, tartós, változatos kivitelben", // 4
    "Strapabíró, színtartó abroszok, textilszalvéták, kültéri-beltéri ülőpárnák" // 5
  ];

  texts.forEach((text, index) => {
    const target = blocks[index]?.querySelector("a > div > div");

    if (target) {
      const info = document.createElement("div");
      info.textContent = text;
      info.style.textAlign = "center";
      info.style.fontWeight = "400";
      info.style.marginTop = "0.5rem";

      target.appendChild(info);
    }
  });
});






/* ADD TO CART BUTTON */
document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector('.shopify-section--main-product buy-buttons > button');
  
  if (button) {
    const textDiv = button.querySelector('div');
    
    // Hozzáadjuk a nyilat csak ha még nincs ott
    if (!button.querySelector('.arrow')) {
      const arrow = document.createElement('span');
      arrow.classList.add('arrow');
      arrow.textContent = '→';
      textDiv.appendChild(arrow);
    }
  }
});


/* OFFER */
document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector('#shopify-section-template--18481508810941__main .product-info__block-group.product-info__offer-list > div:nth-child(2)');

  if (target) {
    // Link létrehozása
    const link = document.createElement('a');
    link.href = 'tel:06306282713';
    link.style.display = 'block';
    link.style.textDecoration = 'none';
    link.style.color = 'inherit'; // Megőrzi az eredeti színt
    link.style.width = '100%';
    link.style.height = '100%';

    // Áthelyezzük a target tartalmát a linkbe
    while (target.firstChild) {
      link.appendChild(target.firstChild);
    }

    // A targetbe visszarakjuk a linket
    target.appendChild(link);
  }
});



/* OFFER BUTOR */
document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector('#shopify-section-template--18512657416381__main .product-info__block-group.product-info__offer-list > div:nth-child(2)');

  if (target) {
    // Link létrehozása
    const link = document.createElement('a');
    link.href = 'tel:06306282713';
    link.style.display = 'block';
    link.style.textDecoration = 'none';
    link.style.color = 'inherit'; // Megőrzi az eredeti színt
    link.style.width = '100%';
    link.style.height = '100%';

    // Áthelyezzük a target tartalmát a linkbe
    while (target.firstChild) {
      link.appendChild(target.firstChild);
    }

    // A targetbe visszarakjuk a linket
    target.appendChild(link);
  }
});



/* OFFER HOTEL */
document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector('#product-info-8022466134205-template--18513017733309__main > div > safe-sticky > div.product-info__block-group.product-info__offer-list > div:nth-child(2)');

  if (target) {
    // Link létrehozása
    const link = document.createElement('a');
    link.href = 'tel:+36202228620';
    link.style.display = 'block';
    link.style.textDecoration = 'none';
    link.style.color = 'inherit'; // Megőrzi az eredeti színt
    link.style.width = '100%';
    link.style.height = '100%';

    // Áthelyezzük a target tartalmát a linkbe
    while (target.firstChild) {
      link.appendChild(target.firstChild);
    }

    // A targetbe visszarakjuk a linket
    target.appendChild(link);
  }
});
/*window.onload = function() {
  // Function to check product tags and update the shouldHideMapApp variable
  function checkProductTags() {
    // Get all product tag containers in the cart
    const productTagContainers = document.querySelectorAll('.product-tags');

    let shouldHideMapApp = false;

    // Iterate through each product tag container
    productTagContainers.forEach(container => {
      const tags = container.querySelectorAll('.tag');

      tags.forEach(tag => {
        const tagText = tag.textContent.trim().toLowerCase();
        // Check if the tag is exactly 'matrac' or contains 'ágykeret', ensuring the full word match
        if (tagText === 'matrac' || tagText === 'ágykeret' || tagText === 'bútorok' || tagText === 'ágyak' || tagText === 'garnitúra') {
          shouldHideMapApp = true;
        }
      });
    });

    // Save the status to localStorage for persistence across page reloads
    localStorage.setItem('shouldHideMapApp', shouldHideMapApp);

    return { shouldHideMapApp };
  }

  // Function to check for the existence of mapApp element and hide/show specific element if needed
  function checkAndToggleMapApp() {
    const mapAppElement = document.getElementById('mapApp');
    // Check if there's a saved state in localStorage
    const shouldHideMapApp = JSON.parse(localStorage.getItem('shouldHideMapApp')) || false;

    if (mapAppElement) {
      if (shouldHideMapApp) {
        mapAppElement.style.display = 'none';
      } else {
        mapAppElement.style.display = 'block';
      }
    }

    // Simulate click on the "Házhoz szállítás" element when mapApp is hidden
    if (shouldHideMapApp) {
      const deliveryOption = document.querySelector('.sc-dhKdcB.dzMMqF');
      if (deliveryOption) {
        deliveryOption.click(); // Simulate a click on the "Házhoz szállítás" option
      }
    }
  }

  // Set an interval to check for the mapApp visibility every 100ms
  const mapAppCheckInterval = setInterval(checkAndToggleMapApp, 100);

  // Function to handle product removal click (if a product is removed from the cart)
  function handleProductRemoveClick(event) {
    if (event.target.closest('.t4s-page_cart__remove') || event.target.closest('.t4s-quantity-selector.is--minus')) {
      checkAndToggleMapApp();  // Re-check visibility of mapApp after product removal
    }
  }

  // Add event listener to the document to handle clicks on dynamically added remove buttons
  document.addEventListener('click', handleProductRemoveClick);

  // Check the product tags immediately when the page loads
  checkProductTags();
};

*/



/* AKCIÓ */
function updateBadges() {
    document.querySelectorAll("product-card").forEach(card => {
        const badge = card.querySelector("on-sale-badge");
        const salePriceEl = card.querySelector("sale-price");
        const compareAtPriceEl = card.querySelector("compare-at-price");

        if (badge && salePriceEl && compareAtPriceEl) {
            const badgeText = badge.textContent.trim().toLowerCase();
            if (badgeText === "akció" || badgeText === "on sale") {
                const salePrice = parseFloat(salePriceEl.textContent.replace(/[^0-9,]/g, '').replace(',', '.'));
                const compareAtPrice = parseFloat(compareAtPriceEl.textContent.replace(/[^0-9,]/g, '').replace(',', '.'));

                if (!isNaN(salePrice) && !isNaN(compareAtPrice) && compareAtPrice > salePrice) {
                    const discount = Math.round(((compareAtPrice - salePrice) / compareAtPrice) * 100);
                    badge.textContent = `-${discount}%`;
                }
            }
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    updateBadges();

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                updateBadges();
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});






//ARTICLE TEXT SIZE//
const h1Element = document.querySelector('#shopify-section-template--17655992680637__main > div > div.article-banner > div.article-banner__content.text-custom > h1');

if (h1Element) {
    // Count the number of words in the h1 element
    const wordCount = h1Element.textContent.trim().split(/\s+/).length;

    if (wordCount > 3) {
        // Function to set font size based on device
        const setFontSize = () => {
            if (window.innerWidth <= 768) { // Mobile breakpoint
                h1Element.style.fontSize = '30px';
            } else { // Desktop
                h1Element.style.fontSize = '50px';
            }
        };

        // Initial call to set font size
        setFontSize();

        // Adjust font size on window resize
        window.addEventListener('resize', setFontSize);
    }
}


/*
///popup partnereink///

document.addEventListener("DOMContentLoaded", function () {
  // Válaszd ki az első hivatkozást
  const emailLink3 = document.querySelector(
    "#block-template--17655993532605__text_with_icons_MQhYdi-item_pcatRw > div.text-with-icons__text-wrapper > div > p:nth-child(2) > a"
  ); 

  // Popup HTML létrehozása
  const overlay = document.createElement("div");
  overlay.classList.add("overlay-popup");
  document.body.appendChild(overlay);

  const popup = document.createElement("div");
  popup.classList.add("popup");
  popup.innerHTML = `
    <button class="popup-close">X</button>
    <a href="mailto:iroda@czingerhome.hu">iroda@czingerhome.hu</a>
    <button id="copy-email" class="copy-btn">Másolás vágólapra →</button>
  `;
  document.body.appendChild(popup);

  const closeButton = popup.querySelector(".popup-close");
  const copyButton = popup.querySelector("#copy-email");

  // Popup megnyitása mindkét hivatkozásra
  function openPopup(event) {
    event.preventDefault(); // Alapértelmezett kattintási viselkedés megakadályozása
    overlay.style.display = "block";
    popup.style.display = "block";
  }

  emailLink3.addEventListener("click", openPopup);

  // Popup bezárása
  closeButton.addEventListener("click", function () {
    overlay.style.display = "none";
    popup.style.display = "none";
  });

  overlay.addEventListener("click", function () {
    overlay.style.display = "none";
    popup.style.display = "none";
  });

  // Email másolása vágólapra
  copyButton.addEventListener("click", function () {
    const email = "iroda@czingerhome.hu";
    navigator.clipboard.writeText(email).then(() => {
      alert("Email cím másolva a vágólapra!");
    });
  });
});




///popup contact////
document.addEventListener("DOMContentLoaded", function () {
  // Válaszd ki az első hivatkozást
  const emailLink2 = document.querySelector(
    "#shopify-section-template--17655992877245__rich_text_EEWRHY > div > div > div > div > div:nth-child(2) > p > a:nth-child(4)"
  ); 

  // Popup HTML létrehozása
  const overlay = document.createElement("div");
  overlay.classList.add("overlay-popup");
  document.body.appendChild(overlay);

  const popup = document.createElement("div");
  popup.classList.add("popup");
  popup.innerHTML = `
    <button class="popup-close">X</button>
    <a href="mailto:iroda@czingerhome.hu">iroda@czingerhome.hu</a>
    <button id="copy-email" class="copy-btn">Másolás vágólapra →</button>
  `;
  document.body.appendChild(popup);

  const closeButton = popup.querySelector(".popup-close");
  const copyButton = popup.querySelector("#copy-email");

  // Popup megnyitása mindkét hivatkozásra
  function openPopup(event) {
    event.preventDefault(); // Alapértelmezett kattintási viselkedés megakadályozása
    overlay.style.display = "block";
    popup.style.display = "block";
  }

  emailLink2.addEventListener("click", openPopup);

  // Popup bezárása
  closeButton.addEventListener("click", function () {
    overlay.style.display = "none";
    popup.style.display = "none";
  });

  overlay.addEventListener("click", function () {
    overlay.style.display = "none";
    popup.style.display = "none";
  });

  // Email másolása vágólapra
  copyButton.addEventListener("click", function () {
    const email = "iroda@czingerhome.hu";
    navigator.clipboard.writeText(email).then(() => {
      alert("Email cím másolva a vágólapra!");
    });
  });
});




///popup footer////
document.addEventListener("DOMContentLoaded", function () {
  // Válaszd ki az első hivatkozást
  const emailLink1 = document.querySelector(
    ".footer__block a[title='mailto:iroda@czingerhome.hu']"
  ); 

  // Popup HTML létrehozása
  const overlay = document.createElement("div");
  overlay.classList.add("overlay-popup");
  document.body.appendChild(overlay);

  const popup = document.createElement("div");
  popup.classList.add("popup");
  popup.innerHTML = `
    <button class="popup-close">X</button>
    <a href="mailto:iroda@czingerhome.hu">iroda@czingerhome.hu</a>
    <button id="copy-email" class="copy-btn">Másolás vágólapra →</button>
  `;
  document.body.appendChild(popup);

  const closeButton = popup.querySelector(".popup-close");
  const copyButton = popup.querySelector(".copy-btn");

  // Popup megnyitása mindkét hivatkozásra
  function openPopup(event) {
    event.preventDefault(); // Alapértelmezett kattintási viselkedés megakadályozása
    overlay.style.display = "block";
    popup.style.display = "block";
  }

  emailLink1.addEventListener("click", openPopup);

  // Popup bezárása
  closeButton.addEventListener("click", function () {
    overlay.style.display = "none";
    popup.style.display = "none";
  });

  overlay.addEventListener("click", function () {
    overlay.style.display = "none";
    popup.style.display = "none";
  });

  // Email másolása vágólapra
  copyButton.addEventListener("click", function () {
    const email = "iroda@czingerhome.hu";
    navigator.clipboard.writeText(email).then(() => {
      alert("Email cím másolva a vágólapra!");
    });
  });
});
*/


document.addEventListener("DOMContentLoaded", function () {

  // --- Nyelv lekérése ---
  const lang = document.documentElement.lang; // pl. 'hu', 'de', 'sk'

  // --- Szövegek nyelvenként ---
  const texts = {
    hu: {
      copy: "Másolás vágólapra →",
      copied: "Email cím másolva a vágólapra!"
    },
    de: {
      copy: "In Zwischenablage kopieren →",
      copied: "E-Mail-Adresse in die Zwischenablage kopiert!"
    },
    en: {
      copy: "Copy to clipboard →",
      copied: "Email address copied to clipboard!"
    },
    sk: {
      copy: "Skopírovať do schránky →",
      copied: "Emailová adresa bola skopírovaná do schránky!"
    }
  };

  const t = texts[lang] || texts.hu; // ha nem ismert nyelv, magyar alap

  // --- Popup létrehozása és kezelése ---
  function createPopup(emailLinkSelector) {
    const emailLink = document.querySelector(emailLinkSelector);
    if (!emailLink) return;

    const overlay = document.createElement("div");
    overlay.classList.add("overlay-popup");
    document.body.appendChild(overlay);

    const popup = document.createElement("div");
    popup.classList.add("popup");
    popup.innerHTML = `
      <button class="popup-close">X</button>
      <a href="mailto:iroda@czingerhome.hu">iroda@czingerhome.hu</a>
      <button class="copy-btn">${t.copy}</button>
    `;
    document.body.appendChild(popup);

    const closeButton = popup.querySelector(".popup-close");
    const copyButton = popup.querySelector(".copy-btn");

    function openPopup(event) {
      event.preventDefault();
      overlay.style.display = "block";
      popup.style.display = "block";
    }

    emailLink.addEventListener("click", openPopup);

    closeButton.addEventListener("click", () => {
      overlay.style.display = "none";
      popup.style.display = "none";
    });

    overlay.addEventListener("click", () => {
      overlay.style.display = "none";
      popup.style.display = "none";
    });

    copyButton.addEventListener("click", () => {
      navigator.clipboard.writeText("iroda@czingerhome.hu").then(() => {
        alert(t.copied);
      });
    });
  }

  // --- Popupok létrehozása a selectorokkal ---
  createPopup("#block-template--17655993532605__text_with_icons_MQhYdi-item_pcatRw > div.text-with-icons__text-wrapper > div > p:nth-child(2) > a");
  createPopup("#shopify-section-template--17655992877245__rich_text_EEWRHY > div > div > div > div > div:nth-child(2) > p > a:nth-child(4)");
  createPopup(".footer__block a[title='mailto:iroda@czingerhome.hu']");

});








///Article header black///
document.addEventListener('DOMContentLoaded', function () {
    const menu = document.querySelector('.header__wrapper'); // Menü kiválasztása
    const logo = document.querySelector('#shopify-section-sections--17655993401533__header > height-observer > store-header > div > a > img.header__logo-image.header__logo-image--transparent'); // Logó kiválasztása
    const articleBanner = document.querySelector('.article-banner'); // Ellenőrizzük, hogy van-e article-banner osztály

    // Ellenőrizzük, hogy a szükséges elemek léteznek
    if (menu && logo && articleBanner) {
        // Ha az article-banner osztály megtalálható
        menu.style.color = '#000'; // A menü teljes szövegének fekete színre állítása
        logo.style.filter = 'invert(1)'; // A logó invertálása (fehér színre változtatja)
    }
});









//////////////////////TERMÉKEINK//////////////
document.addEventListener('DOMContentLoaded', function () {
  const scrollIndicator = document.getElementById('scroll-indicator');
  const lastSlide = document.querySelector('#shopify-section-template--17655993499837__multi_column_scroll_rzjDLB > div > div > div > div:nth-child(10)');
  const firstSlide = document.querySelector('#shopify-section-template--17655993499837__multi_column_scroll_rzjDLB > div > div > div > div:nth-child(1)');

  if (!scrollIndicator || !lastSlide || !firstSlide) {
    console.error('A szükséges elemek nem találhatóak!');
    return;
  }

  // Figyeljük az utolsó elemet, hogy mikor kerül a képernyőre
  const observerLastSlide = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Ha az utolsó elem látható, tüntessük el a nyilat
        scrollIndicator.style.transition = 'opacity 1s ease-out';  // Fokozatos eltűnés
        scrollIndicator.style.opacity = '0';  // Nyíl eltűnik
      }
    });
  }, { threshold: 0.1 });  // 10%-os láthatóság

  observerLastSlide.observe(lastSlide);  // Figyeljük az utolsó slide-ot

  // Figyeljük az első elemet, hogy mikor kerül a képernyőre
  const observerFirstSlide = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Ha az első elem látható, jelenítsük meg a nyilat
        scrollIndicator.style.transition = 'opacity 1s ease-in';  // Fokozatos megjelenés
        scrollIndicator.style.opacity = '1';  // Nyíl látható
      }
    });
  }, { threshold: 0.1 });  // 10%-os láthatóság

  observerFirstSlide.observe(firstSlide);  // Figyeljük az első slide-ot
});



document.addEventListener('DOMContentLoaded', function() {
    // Kiválasztja a megfelelő <legend> elemet
    const legend = document.querySelector('.variant-picker__option-info legend.text-subdued');

    // Ellenőrzi, hogy az elem létezik-e és a tartalma "Size:"
    if (legend && legend.textContent.trim() === 'Size:') {
        // Átírja a szövegét "Méret:"-re
        legend.textContent = 'Méret:';
    }
});


/*
document.addEventListener("DOMContentLoaded", function () {
    const emailElement = document.querySelector("#block-template--17655993532605__text_with_icons_MQhYdi-item_pcatRw > div.text-with-icons__text-wrapper > div > p:nth-child(2)");
    if (emailElement) {
        // A kurzor pointerre változtatása
        emailElement.style.cursor = "pointer";
        
        emailElement.addEventListener("click", function () {
            const email = "iroda@czingerhome.hu";
            navigator.clipboard.writeText(email).then(function () {
                alert("Az e-mail cím vágólapra másolva: " + email);
            }).catch(function (error) {
                console.error("Hiba történt a másolás során: ", error);
            });
        });
    }
});
*/

  //TERMÉK OLDAL


//leírások
document.addEventListener("DOMContentLoaded", function () {
    const sections = document.querySelectorAll('.shopify-section--multiple-images-with-text');

    sections.forEach(section => {
        // Szöveges elemek keresése
        const textContainers = section.querySelectorAll('.prose, .metafield-multi_line_text_field');
        let hasVisibleText = false;

        textContainers.forEach((container) => {
            const rawText = container.textContent.trim();
            if (rawText.length > 0) {
                hasVisibleText = true;
            }
        });

        // Kép keresése
        const hasImage = section.querySelector("img") !== null;

        // Szekció eltávolítása, ha nincs szöveg és nincs kép
        if (!hasVisibleText && !hasImage) {
            section.remove();
        }
    });
});

/* SCROLLING TEXT */
document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector('.shopify-section--images-and-text-scrolling');

    if (section) {
        // Szöveges elemek keresése
        const textContainers = section.querySelectorAll('.prose, .metafield-multi_line_text_field');
        let hasVisibleText = false;

        textContainers.forEach((container) => {
            const rawText = container.textContent.trim();
            if (rawText.length > 0) {
                hasVisibleText = true;
            }
        });

        // Kép keresése
        const hasImage = section.querySelector("img") !== null;

        // Szekció eltávolítása, ha nincs szöveg és nincs kép
        if (!hasVisibleText && !hasImage) {
            section.remove();
        }
    }
});

/* MULTIPLE IMAGES WITH TEXT */
document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector('.shopify-section--multiple-images-with-text');

    if (section) {
        // Szöveges elemek keresése
        const textContainers = section.querySelectorAll('.prose, .metafield-multi_line_text_field');
        let hasVisibleText = false;

        textContainers.forEach((container) => {
            const rawText = container.textContent.trim();
            if (rawText.length > 0) {
                hasVisibleText = true;
            }
        });

        // Kép keresése
        const hasImage = section.querySelector("img") !== null;

        // Szekció eltávolítása, ha nincs szöveg és nincs kép
        if (!hasVisibleText && !hasImage) {
            section.remove();
        }
    }
});

//vélemény
document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector('#shopify-section-template--17655993041085__press_6hGWBQ');

    if (section) {
        // Szöveges elemek keresése
        const textContainers = section.querySelectorAll('.blockquote, .press__author');
        let hasVisibleText = false;

        textContainers.forEach((container) => {
            const rawText = container.textContent.trim();
            if (rawText.length > 0) {
                hasVisibleText = true;
            }
        });

        // Kép keresése
        const hasImage = section.querySelector("img") !== null;

        // Ha nincs látható szöveg és nincs kép, eltávolítjuk a szekciót
        if (!hasVisibleText && !hasImage) {
            section.remove();
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector('#shopify-section-template--18481508810941__press_6hGWBQ');

    if (section) {
        // Szöveges elemek keresése
        const textContainers = section.querySelectorAll('.blockquote, .press__author');
        let hasVisibleText = false;

        textContainers.forEach((container) => {
            const rawText = container.textContent.trim();
            if (rawText.length > 0) {
                hasVisibleText = true;
            }
        });

        // Kép keresése
        const hasImage = section.querySelector("img") !== null;

        // Ha nincs látható szöveg és nincs kép, eltávolítjuk a szekciót
        if (!hasVisibleText && !hasImage) {
            section.remove();
        }
    }
});



document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector('#shopify-section-template--18512657416381__press_6hGWBQ');

    if (section) {
        // Szöveges elemek keresése
        const textContainers = section.querySelectorAll('.blockquote, .press__author');
        let hasVisibleText = false;

        textContainers.forEach((container) => {
            const rawText = container.textContent.trim();
            if (rawText.length > 0) {
                hasVisibleText = true;
            }
        });

        // Kép keresése
        const hasImage = section.querySelector("img") !== null;

        // Ha nincs látható szöveg és nincs kép, eltávolítjuk a szekciót
        if (!hasVisibleText && !hasImage) {
            section.remove();
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector('#shopify-section-template--18513017733309__press_6hGWBQ');

    if (section) {
        // Szöveges elemek keresése
        const textContainers = section.querySelectorAll('.blockquote, .press__author');
        let hasVisibleText = false;

        textContainers.forEach((container) => {
            const rawText = container.textContent.trim();
            if (rawText.length > 0) {
                hasVisibleText = true;
            }
        });

        // Kép keresése
        const hasImage = section.querySelector("img") !== null;

        // Ha nincs látható szöveg és nincs kép, eltávolítjuk a szekciót
        if (!hasVisibleText && !hasImage) {
            section.remove();
        }
    }
});
//videó
document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector('.shopify-section--video');

    if (section) {
        // Ellenőrizzük, hogy van-e videó
        const hasVideo = section.querySelector("video") !== null;

        // Ha nincs videó, eltávolítjuk a szekciót
        if (!hasVideo) {
            section.remove();
        }
    }
});
//tanúsítvány
document.addEventListener("DOMContentLoaded", function () {
    const sections = document.querySelectorAll('.shopify-section--multiple-images-with-text');

    sections.forEach(section => {
        // Ellenőrizzük, hogy van-e kép
        const hasImages = section.querySelectorAll("img").length > 0;

        // Ellenőrizzük, hogy van-e szöveg
        const hasText = Array.from(section.querySelectorAll(".prose"))
            .some(prose => prose.textContent.trim().length > 0);

        // Ha nincs kép és nincs szöveg, eltávolítjuk a szekciót
        if (!hasImages && !hasText) {
            section.remove();
        }
    });
});


/////footer- newsletter

// Változók a checkbox és gomb kiválasztásához
const checkbox = document.getElementById('accept-privacy');
const submitButton = document.querySelector('#footer-newsletter > div.form-control > div > button');

// Funkció a checkbox állapotának figyelésére
checkbox.addEventListener('change', function() {
  // Ha a checkbox be van pipálva
  if (checkbox.checked) {
    // Gomb engedélyezése, kurzor pointerre állítása
    submitButton.disabled = false;
    submitButton.style.cursor = 'pointer'; // A kurzort pointerre változtatjuk
  } else {
    // Gomb letiltása, kurzor not-allowed-ra állítása
    submitButton.disabled = true;
    submitButton.style.cursor = 'not-allowed'; // A kurzor not-allowed lesz
  }
});


// Inicializálás: alapértelmezés szerint a gomb le van tiltva
document.addEventListener('DOMContentLoaded', function() {
  submitButton.disabled = true; // A gomb letiltása alapból
  submitButton.style.cursor = 'not-allowed'; // Kezdetben "not-allowed" kurzor
});


// Az elem kiválasztása az eredeti ID alapján
const blockElement = document.getElementById('block-template--17655992877245__media_with_text_NnDY3t-image_Yryyjg');

// Ha az elem létezik, hozzáadunk egy új data-id attribútumot
if (blockElement) {
  blockElement.setAttribute('data-id', 'bemutato');
} else {
  console.error('A megadott elem nem található!');
}



document.querySelector('#shopify-section-template--17655992811709__image-link-blocks > div > div > section-header > div > h2').setAttribute('reveal-on-scroll', 'false');



//nyelvválasztó
document.addEventListener("DOMContentLoaded", function() {
  console.log('[locale-switch] DOMContentLoaded');

  const countryButtons = document.querySelectorAll('form.shopify-localization-form [name="country_code"]');
  console.log('[locale-switch] Talált ország gombok száma:', countryButtons.length);

  countryButtons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const selectedCountry = e.currentTarget.value;
      console.log('[locale-switch] Ország választva:', selectedCountry);

      let localeCode = null;

      if (selectedCountry === 'DE' || selectedCountry === 'AT') {
        localeCode = 'de';
      } else if (selectedCountry === 'HU') {
        localeCode = 'hu';
      }

      // Új formot építünk, ami egyszerre küldi el mindkettőt
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/localization';

      // Shopify kötelező mezők
      form.innerHTML = `
        <input type="hidden" name="form_type" value="localization">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="_method" value="put">
        <input type="hidden" name="country_code" value="${selectedCountry}">
        ${localeCode ? `<input type="hidden" name="locale_code" value="${localeCode}">` : ''}
      `;

      document.body.appendChild(form);
      console.log('[locale-switch] Egyesített form beküldése:', {country: selectedCountry, locale: localeCode});
      form.submit();
    });
  });
});







